import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7d56bc96")

_pushScopeId("data-v-7d56bc96")
const _hoisted_1 = { id: "home" }
const _hoisted_2 = { id: "realEstate" }
const _hoisted_3 = { id: "carouselShowcase" }
const _hoisted_4 = {
  class: "container section-container",
  id: "introduction"
}
const _hoisted_5 = { class: "d-flex flex-column flex-md-row justify-content-center align-items-center introduction-container" }
const _hoisted_6 = {
  id: "listing",
  class: "container section-container"
}
const _hoisted_7 = {
  id: "events",
  class: "container section-container"
}
const _hoisted_8 = {
  id: "group-members",
  class: "container section-container"
}
const _hoisted_9 = {
  id: "advertisements",
  class: "container section-container"
}
const _hoisted_10 = { id: "contactInfo" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Header = _resolveComponent("Header")
  const _component_Carousel = _resolveComponent("Carousel")
  const _component_Bar = _resolveComponent("Bar")
  const _component_IntroductionBar = _resolveComponent("IntroductionBar")
  const _component_Cards = _resolveComponent("Cards")
  const _component_Teams = _resolveComponent("Teams")
  const _component_ImgAnimation = _resolveComponent("ImgAnimation")
  const _component_Advertisements = _resolveComponent("Advertisements")
  const _component_Footer = _resolveComponent("Footer")
  const _component_ChatButton = _resolveComponent("ChatButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Header, { ref: "toggleNav" }, null, 512),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Carousel)
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_Bar, {
            class: "col-sm-4 company-intro-title",
            title: _ctx.$t('homePage.introduction.title')
          }, null, 8, ["title"]),
          _createVNode(_component_IntroductionBar, { class: "col-sm-8 company-intro-content mb-0 pe-0 pe-md-5" })
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_Bar, {
          title: _ctx.$t('homePage.listing.title')
        }, null, 8, ["title"]),
        _createVNode(_component_Cards, { data: $setup.listingData }, null, 8, ["data"])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_Bar, {
          title: _ctx.$t('homePage.events.title')
        }, null, 8, ["title"]),
        _createVNode(_component_Teams, { data: $setup.eventData }, null, 8, ["data"])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_Bar, {
          title: _ctx.$t('homePage.team.title')
        }, null, 8, ["title"]),
        _createVNode(_component_ImgAnimation)
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode(_component_Bar, {
          title: _ctx.$t('homePage.adv.title')
        }, null, 8, ["title"]),
        _createVNode(_component_Advertisements, { data: $setup.posterData }, null, 8, ["data"])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode(_component_Footer)
      ]),
      _createVNode(_component_ChatButton)
    ])
  ]))
})